export const truncateLabel = (label: string, maxLength: number = 15) => {
  if (label.length <= maxLength) return label;
  return `${label.slice(0, maxLength)}...`;
};

export const getXAxisInterval = (dataLength: number) => {
  if (dataLength <= 25) return 0; // Show all if 25 or fewer
  return Math.ceil(dataLength / 25) - 1; // Calculate interval to show exactly 25 ticks
};
